export function trackSegmentEvent(name, properties) {
  if (!window.analytics) {
    return;
  }

  const superProperties = {
    email: window.analytics.user().traits().email,
    sk_source: 'wp-js',
  };

  window.analytics.track(name, {...superProperties, ...properties});
}
